/* Gharbaar theme script. One file, no framework, no build step.
   Behaviour is attached by data-attributes and a few custom elements, so markup
   can be restyled freely without touching this file. */
(() => {
  'use strict';

  const T = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktop = () => window.matchMedia('(min-width: 820px)').matches;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2800);
  }

  /* ---------- Header height ---------- */
  function measureHeader() {
    const h = $('.section-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
    const a = $('.section-announce');
    document.documentElement.style.setProperty('--ann-h', (a ? a.offsetHeight : 0) + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader, { passive: true });

  /* ---------- Announcement bar: hides on scroll down, slides back on scroll up ---------- */
  (() => {
    const bar = $('.section-announce');
    if (!bar) return;
    const root = document.documentElement;
    let lastY = window.scrollY;
    let ticking = false;
    const update = () => {
      ticking = false;
      const y = window.scrollY;
      const delta = y - lastY;
      if (y <= bar.offsetHeight) root.classList.remove('ann-hidden');
      else if (delta > 6) root.classList.add('ann-hidden');
      else if (delta < -6) root.classList.remove('ann-hidden');
      if (Math.abs(delta) > 6 || y <= bar.offsetHeight) lastY = y;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  })();

  /* ---------- Cart checkout opens the COD order form ----------
     Releasit (COD Form & Upsells) hides every checkout button that lacks
     data-rsi-cod-button and does not hook into this theme's cart drawer. Its
     popup only holds the WHOLE cart on the /cart page (elsewhere it is in
     single-product mode), so:
       - on /cart the button opens the popup directly;
       - anywhere else (cart drawer) it goes to /cart?cod=1, which opens the popup
         as soon as Releasit has loaded the cart.
     If the app is not on the page, the button falls through to Shopify checkout. */
  const onCartPage = () => window.location.pathname.replace(/\/$/, '') === '/cart';
  const rsiReady = () => window._rsiV2 && typeof window._rsiV2.setState === 'function';
  const openCodForm = () => { window._rsiV2.setState({ isOpen: true }); };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cod-checkout]');
    if (!btn) return;
    if (onCartPage()) {
      if (!rsiReady()) return; // let it submit to Shopify checkout
      e.preventDefault();
      e.stopPropagation();
      openCodForm();
      return;
    }
    if (!document.querySelector('script[src*="releasit"]') && !rsiReady()) return;
    e.preventDefault();
    e.stopPropagation();
    btn.classList.add('is-loading');
    window.location.href = '/cart?cod=1';
  }, true);
  if (onCartPage() && new URLSearchParams(window.location.search).has('cod')) {
    history.replaceState(null, '', window.location.pathname);
    let tries = 0;
    const waitForCart = setInterval(() => {
      tries += 1;
      const st = rsiReady() && window._rsiV2.getState();
      if (st && st.products && st.products.length) { clearInterval(waitForCart); openCodForm(); }
      else if (tries > 40) clearInterval(waitForCart); // ~10s: leave the cart page as is
    }, 250);
  }

  /* ---------- Drawers (nav, search, cart, filters) ---------- */
  const Drawers = {
    current: null,
    lastFocus: null,
    open(name) {
      const d = $(`[data-drawer="${name}"]`);
      if (!d) return false;
      if (this.current && this.current !== d) this.close(true);
      this.lastFocus = document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      this.current = d;
      const focusTarget = $('[data-search-input]', d) || $('.drawer__panel', d);
      setTimeout(() => focusTarget && focusTarget.focus({ preventScroll: true }), 50);
      return true;
    },
    close(silent) {
      const d = this.current;
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      this.current = null;
      if (!silent && this.lastFocus) this.lastFocus.focus({ preventScroll: true });
    }
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (Drawers.open(opener.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); Drawers.close(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { Drawers.close(); closeWa(); }
  });

  /* ---------- Cart ---------- */
  const SECTIONS = ['cart-drawer'];

  function renderCart(sections) {
    if (!sections || !sections['cart-drawer']) return;
    const fresh = $('#CartDrawerInner', parseHTML(sections['cart-drawer']));
    const current = $('#CartDrawerInner');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    const count = fresh.dataset.cartCountValue || '0';
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
  }

  async function cartPost(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }

  async function addItems(items, { btn, redirect } = {}) {
    if (btn) btn.classList.add('is-loading');
    try {
      const data = await cartPost(T.routes.cartAdd + '.js', { items });
      if (redirect) { window.location.href = redirect; return; }
      renderCart(data.sections);
      Drawers.open('cart');
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Math.max(1, Number(fd.get('quantity') || 1));
    if (!id) return;
    const submitter = e.submitter || $('[type="submit"]', form);
    const buyNow = submitter && submitter.hasAttribute('data-buy-now');
    addItems([{ id, quantity }], { btn: submitter, redirect: buyNow ? '/checkout' : null });
  });

  document.addEventListener('click', (e) => {
    const multi = e.target.closest('[data-add-multiple]');
    if (multi) {
      const items = multi.dataset.addMultiple.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
      addItems(items, { btn: multi });
      return;
    }
    const change = e.target.closest('[data-line-change]');
    if (change) {
      const line = Number(change.dataset.lineChange);
      const quantity = Math.max(0, Number(change.dataset.qty));
      const row = change.closest('.line');
      if (row) row.classList.add('is-busy');
      cartPost(T.routes.cartChange + '.js', { line, quantity })
        .then((data) => {
          if ($('[data-cart-page]')) { window.location.reload(); return; }
          renderCart(data.sections);
        })
        .catch((err) => { toast(err.message); if (row) row.classList.remove('is-busy'); });
    }
  });

  /* ---------- Quantity stepper ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = $('input', step.closest('[data-qty]'));
    const min = Number(input.min || 1);
    const max = Number(input.max || 99);
    input.value = Math.min(max, Math.max(min, Number(input.value || 1) + Number(step.dataset.qtyStep)));
  });

  /* ---------- Product page: variants ---------- */
  function initPdp(pdp) {
    const picker = $('[data-variant-picker]', pdp);
    const form = $('[data-product-form]', pdp);
    const gallery = $('media-gallery', pdp);

    if (picker && form) {
      const variants = JSON.parse($('[data-variants]', picker).textContent);
      picker.addEventListener('change', async (e) => {
        if (!e.target.matches('input[type="radio"]')) return;
        const selected = $$('fieldset', picker).map((fs) => ($('input:checked', fs) || {}).value);
        $$('[data-option-label]', picker).forEach((el, i) => { el.textContent = selected[i] || ''; });
        const v = variants.find((x) => x.options.every((o, i) => o === selected[i]));
        const addBtn = $('[data-add-btn]', pdp);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }
        $('[data-variant-id]', form).value = v.id;
        const url = `${pdp.dataset.url}?variant=${v.id}`;
        window.history.replaceState({}, '', url);
        if (v.media && gallery) gallery.goToMedia(v.media);
        try {
          const html = await (await fetch(`${url}&section_id=${pdp.dataset.sectionId}`)).text();
          const doc = parseHTML(html);
          $$('[data-pdp-update]', pdp).forEach((el) => {
            // Update in place so observers holding these elements stay attached.
            const fresh = $(`[data-pdp-update="${el.dataset.pdpUpdate}"]`, doc);
            if (!fresh) return;
            el.innerHTML = fresh.innerHTML;
            el.className = fresh.className;
            if ('disabled' in el) el.disabled = fresh.hasAttribute('disabled');
          });
          const stickyBtn = $('[data-sticky-add]', pdp);
          if (stickyBtn) stickyBtn.disabled = !v.available;
          const buyNow = $('[data-buy-now]', pdp);
          if (buyNow) buyNow.disabled = !v.available;
        } catch (err) { /* keep current markup */ }
      });
    }

    /* Sticky add-to-cart bar (mobile) */
    const bar = $('[data-sticky-buy]', pdp);
    const anchor = $('[data-add-btn]', pdp);
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(anchor);
      /* With the Releasit COD form installed, the sticky bar is the COD button:
         it clicks the app's own button (right variant + quantity). Otherwise it adds to cart. */
      const stickyAdd = $('[data-sticky-add]', bar);
      if (document.querySelector('script[src*="releasit"]')) {
        const label = $('[data-sticky-label]', stickyAdd);
        if (label) label.textContent = 'Order now';
      }
      stickyAdd.addEventListener('click', () => {
        const cod = $('#rsi_buy_now_button', pdp);
        if (cod) { cod.click(); return; }
        const btn = $('[data-add-btn]', pdp);
        if (form && btn) form.requestSubmit(btn);
      });
    }
  }
  $$('[data-pdp]').forEach(initPdp);

  /* ---------- Gallery ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      this.thumbs = $$('[data-gallery-thumb]', this);
      this.counter = $('[data-gallery-current]', this);
      if (!this.track) return;
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.galleryThumb))));
      const count = this.track.children.length;
      const step = (dir) => this.go((this.index + dir + count) % count);
      const prev = $('[data-gallery-prev]', this);
      const next = $('[data-gallery-next]', this);
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
      $$('[data-zoom]', this).forEach((frame) => {
        frame.addEventListener('pointermove', (e) => {
          if (!isDesktop() || e.pointerType !== 'mouse') return;
          const r = frame.getBoundingClientRect();
          frame.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%');
          frame.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%');
          frame.classList.add('is-zoomed');
        });
        frame.addEventListener('pointerleave', () => frame.classList.remove('is-zoomed'));
        frame.addEventListener('click', () => { if (isDesktop()) this.openImage(frame); });
      });

      /* Image popup (desktop): click an image or the magnifier button */
      this.box = $('[data-img-lightbox]', this);
      this.frames = $$('[data-full]', this);
      if (this.box && this.frames.length) {
        document.body.appendChild(this.box); // out of the sticky gallery's stacking context, above the header
        this.boxImg = $('[data-img-target]', this.box);
        this.boxCount = $('[data-img-count]', this.box);
        this.expand = $('[data-gallery-expand]', this);
        if (this.expand) this.expand.addEventListener('click', () => {
          const slide = this.track.children[this.index];
          const frame = slide && $('[data-full]', slide);
          this.openImage(frame || this.frames[0]);
        });
        $$('[data-img-close]', this.box).forEach((el) => el.addEventListener('click', () => this.closeImage()));
        $('[data-img-prev]', this.box).addEventListener('click', () => this.stepImage(-1));
        $('[data-img-next]', this.box).addEventListener('click', () => this.stepImage(1));
        this.onKey = (e) => {
          if (!this.box.classList.contains('is-open')) return;
          if (e.key === 'Escape') this.closeImage();
          if (e.key === 'ArrowLeft') this.stepImage(-1);
          if (e.key === 'ArrowRight') this.stepImage(1);
        };
        document.addEventListener('keydown', this.onKey);
        this.box.classList.toggle('is-single', this.frames.length < 2);
        /* swipe left / right inside the popup on touch screens */
        let x0 = null, y0 = null;
        this.box.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        this.box.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          const dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.stepImage(dx < 0 ? 1 : -1);
        }, { passive: true });
      }
      this.sync();
    }
    disconnectedCallback() {
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      if (this.box && this.box.parentNode === document.body) this.box.remove();
    }
    openImage(frame) {
      if (!this.box || !frame) return;
      this.boxIndex = Math.max(0, this.frames.indexOf(frame));
      this.showImage();
      this.box.classList.add('is-open');
      this.box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      frame.classList.remove('is-zoomed');
      $('[data-img-next]', this.box).focus({ preventScroll: true });
    }
    showImage() {
      const f = this.frames[this.boxIndex];
      const shown = $('img', f);
      /* show the already-loaded gallery image at once, then swap in the full-size file when it arrives */
      const token = (this.boxToken = (this.boxToken || 0) + 1);
      if (shown && shown.currentSrc) this.boxImg.src = shown.currentSrc;
      const full = new Image();
      full.onload = () => { if (token === this.boxToken) this.boxImg.src = full.src; };
      full.src = f.dataset.full;
      this.boxImg.alt = f.dataset.alt || '';
      if (this.boxCount) this.boxCount.textContent = `${this.boxIndex + 1} / ${this.frames.length}`;
    }
    stepImage(dir) {
      this.boxIndex = (this.boxIndex + dir + this.frames.length) % this.frames.length;
      this.showImage();
    }
    closeImage() {
      this.box.classList.remove('is-open');
      this.box.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      /* land the gallery on the image they were last looking at */
      const slide = this.frames[this.boxIndex] && this.frames[this.boxIndex].closest('.gallery__slide');
      if (slide) this.go(Number(slide.dataset.index));
      if (this.expand) this.expand.focus({ preventScroll: true });
    }
    get index() { return Math.round(this.track.scrollLeft / this.track.clientWidth); }
    sync() {
      const i = this.index;
      this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      if (this.counter) this.counter.textContent = i + 1;
      if (this.expand) { const slide = this.track.children[i]; this.expand.hidden = !(slide && $('[data-full]', slide)); }
      $$('video', this.track).forEach((v, n) => { if (!v.paused && v.closest('.gallery__slide').dataset.index != i) v.pause(); });
    }
    go(i) { this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    goToMedia(id) {
      const slide = $(`[data-media-id="${id}"]`, this.track);
      if (slide) this.go(Number(slide.dataset.index));
    }
  }
  customElements.define('media-gallery', MediaGallery);

  /* ---------- Delivery estimate ---------- */
  function fmtDate(days) {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function eta(city) {
    const D = T.delivery || {};
    const fast = (D.fast || []).map((c) => c.trim().toLowerCase()).includes(String(city).trim().toLowerCase());
    const [a, b] = fast ? D.fastRange : D.slowRange;
    return `${fmtDate(a)} – ${fmtDate(b)}`;
  }
  $$('[data-eta]').forEach((box) => {
    const select = $('[data-eta-city]', box);
    const out = $('[data-eta-out]', box);
    const saved = store.get('gb:city');
    if (saved && $$('option', select).some((o) => o.value === saved)) select.value = saved;
    const update = () => { out.textContent = eta(select.value); store.set('gb:city', select.value); };
    select.addEventListener('change', update);
    update();
  });

  /* ---------- Sale countdown ---------- */
  const countdowns = $$('[data-countdown]');
  if (countdowns.length) {
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      countdowns.forEach((el) => {
        if (!el.isConnected) return;
        const left = Math.floor((Date.parse(el.dataset.countdown) - Date.now()) / 1000);
        if (Number.isNaN(left) || left <= 0) {
          (el.closest('[data-countdown-wrap]') || el).remove();
          return;
        }
        const d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        if (el.dataset.countdownStyle === 'blocks') {
          const set = (k, v) => { const n = $(`[data-cd="${k}"]`, el); if (n) n.textContent = pad(v); };
          set('d', d); set('h', h); set('m', m); set('s', s);
        } else {
          el.textContent = `${d}d ${pad(h)}h ${pad(m)}m ${pad(s)}s`;
        }
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Hero slider ---------- */
  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-slider-track]', this);
      this.slides = $$('.slider__slide', this.track);
      this.dots = $$('[data-slider-dot]', this);
      if (this.slides.length < 2) return;
      this.interval = Number(this.dataset.interval) || 5000;
      this.paused = false;
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.sliderDot), true)));
      const prev = $('[data-slider-prev]', this), next = $('[data-slider-next]', this);
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
      ['mouseenter', 'touchstart', 'focusin'].forEach((ev) => this.addEventListener(ev, () => { this.paused = true; }, { passive: true }));
      ['mouseleave', 'touchend', 'focusout'].forEach((ev) => this.addEventListener(ev, () => { this.paused = false; this.last = Date.now(); }, { passive: true }));
      if (this.dataset.autoplay === 'true' && !reduceMotion) {
        this.last = Date.now();
        this.timer = setInterval(() => {
          if (this.paused || document.hidden || Date.now() - this.last < this.interval) return;
          this.go(this.index + 1);
        }, 400);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    get index() { return Math.round(this.track.scrollLeft / this.track.clientWidth); }
    go(i, user) {
      const n = this.slides.length;
      const target = ((i % n) + n) % n;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.last = Date.now();
      if (user) this.paused = false;
    }
    sync() { const i = this.index; this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i)); }
  }
  customElements.define('hero-slider', HeroSlider);

  /* ---------- Trust marquee ---------- */
  class TrustMarquee extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-marquee-track]', this);
      this.set = $('[data-marquee-set]', this);
      if (!this.track || !this.set || reduceMotion) return;
      this.items = Array.from(this.set.children).map((el) => el.cloneNode(true));
      if (!this.items.length) return;
      this.build();
      let t;
      window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => this.build(), 200); }, { passive: true });
      // Desktop shows a static row; the marquee is mobile only.
      window.matchMedia('(min-width: 820px)').addEventListener('change', () => this.build());
      this.addEventListener('touchstart', () => this.classList.add('is-paused'), { passive: true });
      this.addEventListener('touchend', () => this.classList.remove('is-paused'), { passive: true });
    }
    build() {
      // Reset to one set of the original items, repeat until wider than the host, then double it.
      this.track.querySelectorAll('[data-marquee-clone]').forEach((el) => el.remove());
      this.set.replaceChildren(...this.items.map((el) => el.cloneNode(true)));
      if (isDesktop()) { this.classList.remove('is-running'); return; }
      let guard = 0;
      while (this.set.scrollWidth < this.clientWidth && guard++ < 20) {
        this.items.forEach((el) => {
          const c = el.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          this.set.appendChild(c);
        });
      }
      const copy = this.set.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-marquee-clone', '');
      copy.removeAttribute('data-marquee-set');
      this.track.appendChild(copy);
      const speed = Number(this.dataset.speed) || 80;
      this.style.setProperty('--marquee-dur', (this.set.scrollWidth / speed).toFixed(2) + 's');
      this.classList.add('is-running');
    }
  }
  customElements.define('trust-marquee', TrustMarquee);

  /* ---------- Sticky video reel (product pages) ----------
     Same behaviour as the WAQT build: muted loop in a corner, tap opens a big
     player with the SAME <video> moved in (never cloned), dismissal remembered
     for the session. Gharbaar change: the video only starts loading when the
     reel appears (preload="none", no autoplay attribute). */
  class StickyVideo extends HTMLElement {
    connectedCallback() {
      this.video = $('.svid__video', this);
      if (!this.video) return;
      this.frame = $('.svid__frame', this);
      this.box = $('[data-svid-lightbox]', this);
      this.stage = $('[data-svid-stage]', this);
      $$('[data-svid-close]', this).forEach((el) => el.addEventListener('click', () => this.close()));
      const sound = $('[data-svid-sound]', this);
      if (sound) sound.addEventListener('click', (e) => this.toggleSound(e));
      const open = $('[data-svid-open]', this);
      if (open) open.addEventListener('click', () => this.expand());
      $$('[data-svid-lightbox-close]', this).forEach((el) => el.addEventListener('click', () => this.shrink()));
      this.onEsc = (e) => { if (e.key === 'Escape' && this.box.classList.contains('is-open')) this.shrink(); };
      document.addEventListener('keydown', this.onEsc);
      const delay = parseInt(this.dataset.delay, 10);
      this.timer = setTimeout(() => this.show(), Number.isNaN(delay) ? 1000 : delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onEsc);
      document.body.classList.remove('is-locked');
    }
    play() {
      const attempt = this.video.play();
      if (attempt && attempt.catch) attempt.catch(() => this.classList.add('is-paused'));
    }
    async lighterSource() {
      // Liquid only exposes the 1080p MP4; the product JSON lists every rendition.
      try {
        const data = await (await fetch(`${this.dataset.productUrl}.js`)).json();
        const media = (data.media || []).find((m) => String(m.id) === this.dataset.mediaId);
        const mp4s = ((media && media.sources) || []).filter((x) => x.format === 'mp4').sort((a, b) => a.height - b.height);
        const pick = mp4s.find((x) => x.height >= 480) || mp4s[mp4s.length - 1];
        if (pick) this.video.src = pick.url;
      } catch (e) { /* keep the Liquid source */ }
    }
    async show() {
      await this.lighterSource();
      this.classList.add('is-mounted');
      this.video.muted = true;
      this.video.preload = 'auto';
      this.play();
      setTimeout(() => this.classList.add('is-in'), 20);
    }
    expand() {
      this.stage.appendChild(this.video);
      this.video.controls = true;
      this.box.classList.add('is-open');
      this.box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      this.video.muted = false; // a tap is a user gesture, so sound is allowed here
      this.syncSound();
      this.classList.remove('is-paused');
      this.play();
      const x = $('.lightbox__x', this.box);
      if (x) x.focus();
    }
    shrink() {
      this.box.classList.remove('is-open');
      this.box.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      this.frame.insertBefore(this.video, this.frame.firstChild);
      this.video.controls = false;
      this.video.muted = true; // never let an unmuted reel follow the shopper down the page
      this.syncSound();
      this.play();
    }
    close() {
      this.classList.remove('is-in');
      this.video.pause();
      setTimeout(() => this.classList.remove('is-mounted'), 320);
    }
    toggleSound(e) {
      if (e) e.stopPropagation(); // otherwise the click reaches the expand layer
      this.video.muted = !this.video.muted;
      if (this.video.paused) this.play();
      this.syncSound();
    }
    syncSound() {
      const on = !this.video.muted;
      const btn = $('[data-svid-sound]', this);
      const label = $('[data-svid-sound-text]', this);
      const icon = $('.svid__sound-icon', this);
      if (btn) btn.setAttribute('aria-pressed', String(on));
      if (label) label.textContent = on ? 'Sound off' : 'Sound on';
      if (icon) icon.classList.toggle('is-on', on);
    }
  }
  customElements.define('sticky-video', StickyVideo);

  /* The reel lifts above the mobile sticky buy bar; its height includes the
     safe-area inset, so measure it rather than hard-coding. */
  const stickyBuy = $('[data-sticky-buy]');
  if (stickyBuy && 'ResizeObserver' in window) {
    new ResizeObserver(() => document.documentElement.style.setProperty('--sticky-buy-h', stickyBuy.offsetHeight + 'px')).observe(stickyBuy);
  }

  /* ---------- Predictive search ---------- */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('[data-search-input]', this);
      this.results = $('[data-search-results]', this);
      if (!this.input || !this.results) return;
      let timer;
      this.input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.search(this.input.value.trim()), 250);
      });
      this.input.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.hide(); });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.hide(); });
    }
    async search(q) {
      if (q.length < 2) { this.hide(); return; }
      this.controller && this.controller.abort();
      this.controller = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
        const html = await (await fetch(url, { signal: this.controller.signal })).text();
        const fresh = $('[data-ps-results]', parseHTML(html));
        this.results.innerHTML = fresh ? fresh.outerHTML : '';
        this.results.hidden = !fresh;
      } catch (e) { /* aborted */ }
    }
    hide() { this.results.hidden = true; }
  }
  customElements.define('predictive-search', PredictiveSearch);

  /* ---------- Product recommendations (lazy) ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = async () => {
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const fresh = $('product-recommendations', parseHTML(html));
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        } catch (e) { /* leave empty */ }
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Deferred video: nothing downloads until tapped ---------- */
  class DeferredVideo extends HTMLElement {
    connectedCallback() {
      const btn = $('button', this);
      const tpl = $('template', this);
      if (!btn || !tpl) return;
      btn.addEventListener('click', () => {
        this.appendChild(tpl.content.firstElementChild.cloneNode(true));
        btn.remove();
        const v = $('video', this);
        if (v) v.play().catch(() => {});
      }, { once: true });
    }
  }
  customElements.define('deferred-video', DeferredVideo);

  /* Product rail: arrow buttons scroll one page of cards; they disable at either end. */
  class ProductRail extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-rail-track]', this);
      this.prev = $('[data-rail-prev]', this);
      this.next = $('[data-rail-next]', this);
      if (!this.track) return;
      const page = (dir) => this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
      this.prev.addEventListener('click', () => page(-1));
      this.next.addEventListener('click', () => page(1));
      this.sync = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
        this.classList.toggle('prail--static', max <= 0);
      };
      this.track.addEventListener('scroll', this.sync, { passive: true });
      window.addEventListener('resize', this.sync);
      this.sync();
    }
    disconnectedCallback() { window.removeEventListener('resize', this.sync); }
  }
  customElements.define('product-rail', ProductRail);

  /* Review list: show a first batch, "View more" reveals the next batch. */
  class ReviewList extends HTMLElement {
    connectedCallback() {
      this.items = $$('[data-review-items] > *', this);
      this.wrap = $('[data-review-more-wrap]', this);
      this.btn = $('[data-review-more]', this);
      this.batch = () => Number(isDesktop() ? this.dataset.desktop : this.dataset.mobile) || 6;
      this.shown = this.batch();
      this.btn.addEventListener('click', () => {
        const first = this.shown;
        this.shown += this.batch();
        this.render();
        const next = this.items[first];
        if (next) next.focus?.({ preventScroll: true });
      });
      this.mq = window.matchMedia('(min-width: 820px)');
      this.onMq = () => { this.shown = Math.max(this.shown, this.batch()); this.render(); };
      this.mq.addEventListener('change', this.onMq);
      this.render();
    }
    disconnectedCallback() { if (this.mq) this.mq.removeEventListener('change', this.onMq); }
    render() {
      this.items.forEach((el, i) => { el.hidden = i >= this.shown; });
      this.wrap.hidden = this.shown >= this.items.length;
    }
  }
  customElements.define('review-list', ReviewList);

  /* ---------- WhatsApp float ---------- */
  function closeWa() {
    const card = $('#WaFloatCard');
    const btn = $('[data-wa-toggle]');
    if (card) card.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wa-toggle]');
    if (btn) {
      const card = $('#WaFloatCard');
      const open = card.hidden;
      card.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!e.target.closest('[data-wa-float]')) closeWa();
  });

  /* ---------- Accordion: one open at a time ---------- */
  $$('[data-accordion-single]').forEach((group) => {
    group.addEventListener('toggle', (e) => {
      if (!e.target.open) return;
      $$('details[open]', group).forEach((d) => { if (d !== e.target) d.open = false; });
    }, true);
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-auto-submit]')) return;
    const params = new URLSearchParams(window.location.search);
    params.set(e.target.name, e.target.value);
    params.delete('page');
    window.location.search = params.toString();
  });
})();
